import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";

// Thunk for getting Add Offered_Product
export const getOffered_Product = createAsyncThunk(
  "/website/bapat-benifits/benifits",
  async ({id=""}, { rejectWithValue }) => {
    try {
      const offeredproductData = await GET(`${API.GET_Bapat_Benifit}/${id}`);
      return offeredproductData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getOffer = createAsyncThunk(
  "/website/bapat-benifits/offer",
  async (_, { rejectWithValue }) => {
    try {
      const offeredproductData = await GET(`${API.GET_Bapat_Benifit}/offer`);
      return offeredproductData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Create the slice
const Slice = createSlice({
  name: "offeredproduct",
  initialState: {
    content: "",
    bapatbenifits: [],
    offers: [],
    error: null,
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getOffered_Product.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getOffered_Product.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.bapatbenifits = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getOffered_Product.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })
       .addCase(getOffer.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getOffer.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.offers = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getOffer.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      });
  },
});

export default Slice.reducer;
